export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "ja",
    "resource": {
      "update_remark": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["備考を編集する"])}
    }
  })
}
